import client from './client.js';

// Cuentas compartidas. Misma API en la caja central y en la nube.
export const getTabs = (status = 'open') =>
  client.get('/tabs', { params: { status } }).then((r) => r.data.data);

// Idempotente por `id`: reintentar no duplica la cuenta
export const createTab = (tab) =>
  client.post('/tabs', tab).then((r) => r.data);

// `version` habilita el 409 si otra tablet guardó primero
export const updateTab = (id, patch) =>
  client.patch(`/tabs/${encodeURIComponent(id)}`, patch).then((r) => r.data.data);

export const closeTab = (id, { reason = 'paid', payment_client_uuid = null } = {}) =>
  client.post(`/tabs/${encodeURIComponent(id)}/close`, { reason, payment_client_uuid }).then((r) => r.data.data);

// Cambiar la cuenta de mesa. table_id null = sin mesa (para llevar).
export const moveTab = (id, tableId) =>
  client.post(`/tabs/${encodeURIComponent(id)}/move`, { table_id: tableId }).then((r) => r.data);

// Juntar esta cuenta dentro de otra: sus platillos y comandas se van a la
// destino y esta se cierra.
export const mergeTab = (id, intoTabId) =>
  client.post(`/tabs/${encodeURIComponent(id)}/merge`, { into_tab_id: intoTabId }).then((r) => r.data);
